import '@toolkit/vendor/javascripts/zepto-detect'
import '@toolkit/vendor/javascripts/fastclick'
import '@toolkit/vendor/javascripts/modernizr.slim'
import '@toolkit/vendor/javascripts/jquery.textfill'

// Propagate jquery plugins over to Backbone.
import Backbone from '@polleverywhere/backbone'
import './jquery_toggles'

import BaseRouter from '@toolkit/lib/routers/base'

import Cutlass from '@toolkit/lib/services/cutlass'
import Datadog from '@toolkit/lib/services/datadog'
import LoadTime from '@toolkit/lib/services/load_time'
import Logger from '@toolkit/lib/services/logger'

import BEM from '@toolkit/lib/mixins/_bem'
import { View } from '@toolkit/lib/mixins/_view'

import RawSpinner from '@toolkit/lib/spinner'

import Base from '@toolkit/lib/views/base'

import Modal from '@toolkit/components/modal'
import * as Simplifiers from '@toolkit/components/modal/simplifiers'
import Notification from '@toolkit/components/notification'

import FilterPollsTpl from '@toolkit/lib/templates/filter_polls.hamlc'
Backbone.$ = $

PollEv.namespace('PollEv', (PollEv) => {
  PollEv.Spinner = RawSpinner
})

PollEv.namespace('PollEv.Toolkit.Mixin', (Mixin) => {
  Mixin.BEM = BEM
})

PollEv.namespace('PollEv.Mixin', (Mixin) => {
  Mixin.BaseView = View
})

PollEv.namespace('PollEv.Router', (Router) => {
  Router.Base = BaseRouter
})

PollEv.namespace('PollEv.Service', (Service) => {
  Service.Cutlass = Cutlass
  Service.Datadog = Datadog
  Service.LoadTime = LoadTime
  Service.Logger = Logger
})

PollEv.namespace('PollEv.View', (View) => {
  View.Base = Base
})

PollEv.namespace('PollEv.Component', (Component) => {
  Component.Modal = {
    Dialog: Modal,
    alert: Simplifiers.alert,
    confirm: Simplifiers.confirm,
    prompt: Simplifiers.prompt
  }

  Component.Notification = Notification
})

window.JST = window.JST || {}
window.JST['pollev_toolkit/templates/filter_polls'] = FilterPollsTpl
